export default __webpack_public_path__ + "static/images/spot_icon.fe51a546.png";